import axios from "axios";
import * as Config from "./Config";
import { EN_enabled } from "../util";

export enum SessionStatus {
   Active = 0,
   InActive = 1,
}

/**
 * Check with the backend what the session state is.
 */
export const fetchSessionStatus = (): Promise<SessionStatus> =>
   axios
      .get(`${Config.get().base_path}checkSession`)
      .then((_) => SessionStatus.Active)
      .catch((_) => SessionStatus.InActive);

export type RefreshResponse = {
   csrf_token: string;
};

// create a custom client for refreshing the token
// so that we don't use the axios middleware that calls refresh token
// (causing an infinite loop)
const refreshClient = axios.create();

/**
 * The refresh api updates our authentication cookies and provides us with a new csrf token.
 *
 * The cookies will handle the auth tokens, but we need to store the csrf token and attach it to every request.
 */
export function refreshToken(): Promise<RefreshResponse> {
   switch (process.env.DPM_AUTH_STRATEGY) {
      case "vm":
         return refreshClient
            .post<RefreshResponse>("/idm/api/v1/oauth/refresh")
            .then((r) => ({ csrf_token: r.data.csrf_token }));

      default:
         return refreshClient
            .get("/auth/refreshToken")
            .then((r) => r.data.csrf_token ?? "")
            .catch((_) => window.platformUI.csrfToken)
            .then((csrf_token) => ({ csrf_token }));
   }
}

/**
 * Fails with an error message if the user's tenantID is invalid
 */
export const validateTenant = (
   userId: string | null,
   tenantId: string
): Promise<void> => {
   const params = new URLSearchParams({
      tenantId,
      EN_enabled: String(EN_enabled()),
   });

   userId && params.set("userId", userId);

   return axios.get(`/auth/checkUser?${params.toString()}`);
};

export type CreateResponse = {
   tid: string;
};

export const createAccount = async (name: string): Promise<CreateResponse> =>
   axios.post("/auth/createAccount", { name }).then((r) => r.data);
